import {
  TpvAccessCompany,
  TpvAccessUnit,
  TpvUserAccess,
} from '@app/domain/models/tpv/tpv-user-access.model';
import {
  TpvAccessCompanyDto,
  TpvAccessUnitDto,
  TpvUserAccessDto,
} from '@app/data/dtos/tpv/user-access.dto';

function mapUnit(dto: TpvAccessUnitDto): TpvAccessUnit {
  return {
    externalIdUnit: dto.external_id_unit ?? '',
    isPrimary: dto.is_primary ?? false,
    name: dto.name ?? null,
    merchants: (dto.merchants ?? []).map((m) => ({
      idMerchant: m.id_merchant ?? '',
      name: m.name ?? '',
      status: m.status ?? '',
    })),
  };
}

function mapCompany(dto: TpvAccessCompanyDto): TpvAccessCompany {
  return {
    idCompany: Number(dto.id_company ?? 0),
    name: dto.name ?? '',
    externalIdCompany: dto.external_id_company ?? '',
    units: (dto.units ?? []).map(mapUnit),
  };
}

/** Convierte el `extra_data` del backend en el modelo de dominio del árbol de accesos. */
export function mapTpvUserAccess(dto: TpvUserAccessDto): TpvUserAccess {
  return {
    companies: (dto.companies ?? []).map(mapCompany),
    count: Number(dto.count ?? 0),
  };
}
